import React, { useState } from "react";

/**
 * Logo-only mark. Tries to render the official NestVillage PNG; on load
 * failure falls back to the in-app NV gradient tile so headers never break.
 */
export default function BrandLogo({ size = 36, rounded = "rounded-lg" }) {
  const [errored, setErrored] = useState(false);
  const dim = `${size}px`;
  if (errored) {
    return (
      <div
        className={`${rounded} bg-gradient-to-br from-sky-700 to-emerald-600 flex items-center justify-center text-white font-heading font-bold shadow-sm`}
        style={{ width: dim, height: dim, fontSize: Math.round(size * 0.4) }}
        data-testid="brand-logo-fallback"
      >
        NV
      </div>
    );
  }
  return (
    <img
      src="/nestvillage-logo-transparent.png"
      alt="NestVillage LLC"
      width={size}
      height={size}
      style={{ width: dim, height: dim, objectFit: "contain" }}
      onError={() => setErrored(true)}
      data-testid="brand-logo"
    />
  );
}
